module.exports = __webpack_public_path__ + "wordtracker-logo-black.f004d9.png";